import { styled } from "@mui/material";

const Container = styled("div")`
  width: 100%;
  padding: 0;
  background-color: #e7f0f8;
`;

export { Container };
